import React from "react";
import { useAuth } from "../contexts/AuthContext";
import LeftNavBar from "../components/leftnavbar/LeftNavBar";
import { Toolbar, Box, Stack, Grid2 } from "@mui/material";
import { Outlet } from "react-router-dom";
import InternalLeftNavBar from "../components/internalleftnavbar/InternalLeftNavBar";

const InternalDashboard = () => {
    const { user } = useAuth()
    return (
        <>
        <Toolbar />
        <Box sx={{ display: 'flex' }}>
            <InternalLeftNavBar />
            <Stack sx={{ flexGrow: 1, maxWidth: '100vw' }}>
                <Box sx={{p: 3}}>
                    <Outlet />
                </Box>
            </Stack>
        </Box>
        </>
    );
};

export default InternalDashboard;